import { FC, Children } from 'react';

import { ICarouselScrollProps } from '../Carousel.types';
import { CarouselControls } from '../CarouselControls/CarouselControls';
import { useCarouselScrollPresenter } from './CarouselScroll.presenter';
import styles from './CarouselScroll.styles.m.css';

export const CarouselScroll: FC<ICarouselScrollProps> = ({
  children,
  itemsToShow,
  itemWidth,
  gap,
  withShadow,
  activeIndex,
  onChangeActiveIndex,
  scrollByClientWidth,
  isScrollToActiveOnMount,
}) => {
  const childrenArray = Children.toArray(children);

  const presenter = useCarouselScrollPresenter({
    itemWidth,
    gap,
    itemsToShow,
    childrenCount: childrenArray.length,
    activeIndex,
    scrollByClientWidth,
    isScrollToActiveOnMount,
    onChangeActiveIndex,
  });

  return (
    <>
      <div
        ref={presenter.carouselRef}
        className={styles.carouselWrapper}
      >
        <div
          ref={presenter.contentRef}
          className={styles.carousel}
        >
          {Children.map(childrenArray, (child, index) => (
            <div
              className={styles.carouselItem}
              style={{
                flex: `0 0 ${itemWidth}px`,
                marginRight: index < childrenArray.length - 1 ? `${gap}px` : '0',
                paddingRight:
                  scrollByClientWidth && index === childrenArray.length - 1 ? `${gap}px` : '0',
              }}
            >
              {child}
            </div>
          ))}
        </div>
      </div>

      <CarouselControls
        showPrevButton={presenter.showPrevButton}
        showNextButton={presenter.showNextButton}
        withShadow={withShadow}
        onPrev={presenter.scrollPrev}
        onNext={presenter.scrollNext}
      />
    </>
  );
};
